
export const cadastroUsuarioRouter = [{
  path: "/" + process.env.VUE_APP_BASE_URL + "/cadastro/usuario",
  component: () => import("@/template/WrapperRouter.vue"),
  meta: {
    auth: ['CADUSUARIO_MENU'],
  },
  children: [
    {
      path: "novo",
      name: "CADUSUARIO_NOVO_VIEW",
      component: () => import("@/paginas/seguranca/usuario/ContainerUsuario.vue"),
      meta: {
        auth: ['CADUSUARIO_MENU'],
      }
    },
    {
      path: "dados",
      name: "CADUSUARIO_DADOS_VIEW",
      component: () => import("@/paginas/seguranca/usuario/TabPanelDados.vue"),
      meta: {
        auth: ['CADUSUARIO_MENU'],
      }
    },
    {
      path: "novo/vinculos",
      name: "CADUSUARIO_VINCULOS_VIEW",
      component: () => import("@/paginas/seguranca/usuario/TabPanelVinculos.vue"),
      meta: {
        auth: ['CADUSUARIO_MENU'],
      }
    },
    {
      path: "perfil",
      name: "CADUSUARIO_PERFIS_VIEW",
      component: () => import("@/paginas/seguranca/usuario/TabPanelPerfilAcesso.vue"),
      meta: {
        auth: ['CADUSUARIO_MENU'],
      }
    },
  ],
}]
